import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface CrossOrgAssignmentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  deviceOrgName: string | null;
  groupOrgName: string | null;
}

export const CrossOrgAssignmentDialog = ({
  open,
  onOpenChange,
  deviceOrgName,
  groupOrgName,
}: CrossOrgAssignmentDialogProps) => {
  const deviceOrg = deviceOrgName || "No Organization";
  const groupOrg = groupOrgName || "Global (No Organization)";

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            <AlertDialogTitle>Assignment Not Allowed</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3 pt-2">
            <p>
              This device belongs to <strong>{deviceOrg}</strong> but the selected group 
              belongs to <strong>{groupOrg}</strong>.
            </p>
            <p className="text-destructive font-medium">
              Cross-organization device-to-group assignments are not permitted.
            </p>
            <div className="bg-muted p-3 rounded-md text-sm space-y-2">
              <p className="font-medium">To assign this device to a group:</p>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                <li>Select a group that belongs to <strong>{deviceOrg}</strong></li>
                <li>Or ask the {deviceOrg} admin to create and manage groups for their devices</li>
              </ul>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Understood</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
